export default __webpack_public_path__ + "static/media/BakedPenne.7925fe9c.jpg";